import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import type { AssetChargePreview } from '../../../../../core/models/assets/asset-charges.dto';

/** The monthly deduction of a charge next to the employee's salary, with the over-salary warning. */
@Component({
  selector: 'app-asset-charge-preview',
  standalone: true,
  imports: [TranslatePipe],
  templateUrl: './asset-charge-preview.component.html',
  styleUrl: './asset-charge-preview.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AssetChargePreviewComponent {
  readonly preview = input<AssetChargePreview | null>(null);
}
